import _ from 'lodash';
import { createSelector } from 'reselect';

export const getRentHistory = state => _.get(state, 'cvRentHistory');

export const getPayload = createSelector(
  [getRentHistory],
  rentHistory => _.get(rentHistory, 'payload', false),
);

export const getLoading = createSelector(
  [getRentHistory],
  rentHistory => _.get(rentHistory, 'loading', false),
);

export const getError = createSelector(
  [getRentHistory],
  rentHistory => _.get(rentHistory, 'error', false),
);

export const getRentHistoryError = createSelector(
  [getError],
  error => {
    if (error)
      return {
        code: _.get(error, 'code', false),
        message: _.get(error, 'error', false),
      };
    return error;
  },
);

export const getRentHistoryIsEmpty = createSelector(
  [getError],
  error => {
    if (error) return true;
    return error;
  },
);

export const getRentHistorySuccess = createSelector(
  [getPayload],
  payload => !_.isEmpty(payload),
);
